import React from "react";

export default function Spider({ onClick }) {
  return (
    <div className="spider" onClick={onClick}>
      <img src="/img/spider.png" alt="spider" />
    </div>
  );
}

